/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ItemWrap } from '@/components/layouts/ItemWrap';
import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { hideIfChildEmpty, layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const Aside: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		dimensions: { contentSpacing },
		customDimensions: { layoutSpacing },
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
			<Stack
				id="main-content"
				component="main"
				gap={3}
				sx={layoutMainSX(layout.slots.first?.length || 0)}
			>
				<LayoutSlot slot={layout.slots.first} ItemWrap={ItemWrap} />
				<Container component="section">
					<Grid container spacing={4}>
						<Grid
							item
							component="aside"
							xs={12}
							sm={3}
							md={3}
							pt={0}
							aria-label={layout.slots.aside?.at(0)?.name}
							sx={hideIfChildEmpty}
						>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.aside} />
							</Stack>
						</Grid>
						<Grid item component="section" xs={12} sm={9} md={9}>
							<Stack gap={contentSpacing}>
								<LayoutSlot slot={layout.slots.second} />
							</Stack>
						</Grid>
					</Grid>
					<Grid container>
						<Grid item xs={12} md={12}>
							<LayoutSlot slot={layout.slots.third} />
						</Grid>
					</Grid>
				</Container>
			</Stack>
			<LayoutSlot slot={layout.slots.footer} />
		</>
	) : null;
};
